export const SNIPPET_MASTERY_COUNT_CHANGED = 'flashcode:snippetMasteryCountChanged';

/**
 * Broadcast that the user's all-languages mastered snippet count changed.
 * @param {number} [delta=1]
 */
export function notifySnippetMasteryCountChanged(delta = 1) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(SNIPPET_MASTERY_COUNT_CHANGED, {
      detail: { delta: Number.isFinite(delta) ? delta : 1 },
    })
  );
}

/**
 * @param {(delta: number) => void} handler
 * @returns {() => void}
 */
export function subscribeSnippetMasteryCountChanged(handler) {
  if (typeof window === 'undefined') return () => {};
  const listener = (event) => {
    handler(event?.detail?.delta ?? 1);
  };
  window.addEventListener(SNIPPET_MASTERY_COUNT_CHANGED, listener);
  return () => window.removeEventListener(SNIPPET_MASTERY_COUNT_CHANGED, listener);
}
